import React, {Component} from "react";
import "../stylesheets/Teaser.scss";

class Teaser extends Component {

    static chooseTeaser() {
        let teasers = [{
            headline: "Hans Keller, Dachdecker",
            textline: <>Potentielle Auftraggeber lesen auf stadtbranchenbuch.com und 11880.com<br/> positive Bewertungen seiner
                Kunden.</>,
            image: require("../images/shutterstock_615849746.jpg")
        }, {
            headline: "Mario Neubauer, Schreiner",
            textline: <>Erhält Aufträge durch Empfehlungen<br/>auf stadtbranchenbuch.com und 11880.com</>,
            image: require("../images/shutterstock_1224288865.jpg")
        }, {
            headline: "Hannah Kawaro, Stylistin",
            textline: <>Kunden empfehlen ihren Salon<br/>auf stadtbranchenbuch.com und 11880.com</>,
            image: require("../images/shutterstock_710155132.jpg")
        }, {
            headline: "Dr. Miriam Huber, Rechtsanwältin",
            textline: <>Hat ihre Reichweite mit stadtbranchenbuch.com und 11880.com<br/> spürbar verbessert.</>,
            image: require("../images/shutterstock_653970169.jpg")
        }, {
            headline: "Dr. Annette Hoffmann, Zahnärztin",
            textline: <>Ihre Patienten bewerten Sie auf <br/>stadtbranchenbuch.com und 11880.com</>,
            image: require("../images/shutterstock_620003576.jpg")
        }];

        return teasers[Math.floor(Math.random() * teasers.length)]
    }

    render() {
        return (
            <div className={"teaser col-11"}>
                <h2>{this.props.teaser.headline}</h2>
                <p>{this.props.teaser.textline}</p>
            </div>
        );
    }


}

export default Teaser;


